import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=31ba408a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=31ba408a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ba408a')) {
      api.createRecord('31ba408a', component.options)
    } else {
      api.reload('31ba408a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=31ba408a", function () {
      api.rerender('31ba408a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/IncubatorApply/Index.vue"
export default component.exports